import { useRef } from 'react';

export default function useDebounce(fn: Function, delay: number) {
	const timeoutRef = useRef<NodeJS.Timeout>();

	function debounceFn(...rest: any[]) {
		clearTimeout(timeoutRef.current);

		timeoutRef.current = setTimeout(() => {
			fn(...rest);
		}, delay);
	}

	return debounceFn;
}